export const tourStopPoiTemplate = /* html */ `
<h4>{{title}}</h4>
<p class="text-secondary">{{description}}</p>
<div
  class="border-top p-3 pb-0 d-flex justify-content-end gap-2"
  style="margin-left: -16px; margin-right: -16px"
>
  <button
    type="button"
    class="btn btn-outline-secondary"
    data-tour-action-key="endButton"
  ></button>
  <button
    type="button"
    class="btn btn-primary"
    data-tour-action-key="nextButton"
  ></button>
</div>`;
